import {
  GET_RELATIONLOCATION_FAILURE,
  GET_RELATIONLOCATION_REQUEST,
  GET_RELATIONLOCATION_SUCCESS,
  GET_UNMAPPED_WAREHOUSES_BY_LEVEL_REQUEST,
  GET_UNMAPPED_WAREHOUSES_BY_LEVEL_SUCCESS,
  GET_UNMAPPED_WAREHOUSES_BY_LEVEL_FAILURE,
  GET_MAPPED_WAREHOUSES_REQUEST,
  GET_MAPPED_WAREHOUSES_SUCCESS,
  GET_MAPPED_WAREHOUSES_FAILURE,
} from "./relationLocationTypes";

const initialState = {
  loading: false,
  locations: [],
  error: "",
};

const getRelationLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RELATIONLOCATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RELATIONLOCATION_SUCCESS:
      return {
        loading: false,
        locations: action.payload,
        error: "",
      };
    case GET_RELATIONLOCATION_FAILURE:
      return {
        loading: false,
        locations: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUnmappedWarehousesByLevel = {
  loading: false,
  unmappedWarehouses: {},
  error: "",
};

const unmappedWarehousesByLevelReducer = (
  state = initialStateForUnmappedWarehousesByLevel,
  action
) => {
  switch (action.type) {
    case GET_UNMAPPED_WAREHOUSES_BY_LEVEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_UNMAPPED_WAREHOUSES_BY_LEVEL_SUCCESS:
      return {
        loading: false,
        unmappedWarehouses: action.payload,
        error: "",
      };
    case GET_UNMAPPED_WAREHOUSES_BY_LEVEL_FAILURE:
      return {
        loading: false,
        unmappedWarehouses: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMappedWarehouses = {
  loading: false,
  mappedWarehouses: {},
  error: "",
};

const mappedWarehousesReducer = (
  state = initialStateForMappedWarehouses,
  action
) => {
  switch (action.type) {
    case GET_MAPPED_WAREHOUSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MAPPED_WAREHOUSES_SUCCESS:
      return {
        loading: false,
        mappedWarehouses: action.payload,
        error: "",
      };
    case GET_MAPPED_WAREHOUSES_FAILURE:
      return {
        loading: false,
        mappedWarehouses: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getRelationLocationReducer,
  unmappedWarehousesByLevelReducer,
  mappedWarehousesReducer,
};
